import React from 'react';
import { Outlet } from 'react-router-dom';

const PersonalInformation: React.FC = () => {
  return <Outlet />;
};

export default PersonalInformation;
